module.exports = __webpack_public_path__ + "img/home8.6b889772.png";